import React, { useState,useEffect,forwardRef, useImperativeHandle } from 'react';
// import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Select from '../../CommonComponent/ReactSelect';
import * as ConstantOptions from '../../Utils/ConstantOptions';
import compair from '../../CommonComponent/SortDropDown';
import InputMask from '../../CommonComponent/NumberFormat';
import isEmptyValidation from '../../../components/Validation/EmptyError';

let constantOptions = ConstantOptions.DROPDOWN_OPTIONS;
let countiesListFromState = [];

const AddressTab = forwardRef((props,ref) => {
    let setAddressData = props.setAddressData;


    const [address_1, setAddress_1] = useState("");
    const [address_2, setAddress_2] = useState("");
    const [city, setCity] = useState("");
    const [addressState, setAddressState] = useState();
    const [zipCode, setZipCode] = useState("");
    const [county, setCounty] = useState();
  
    const [address_1_isEmpty, setAddress_1_isEmpty] = useState(false);
    const [cityisEmpty, setCityisEmpty] = useState(false);
    const [zipCodeisEmpty, setZipCodeisEmpty] = useState(false);
    const [countyisEmpty, setCountyisEmpty] = useState(false);
    const [addressStateisEmpty, setAddressStateisEmpty] = useState(false);

    useEffect(()=>{
        setAddressData({
        "address_1":address_1,"address_2":address_2,"city":city,
        "addressState":addressState,"zipCode":zipCode,"county":county
        });
    },[address_1,address_2,city,addressState,zipCode,county,setAddressData
    ]);

    useImperativeHandle(ref, () => ({
        validateAddress() {
            
            let isValidAddress = true;

            let isEmptyValidationArray=[
                {"fieldName":address_1,"functionName":setAddress_1_isEmpty},
                {"fieldName":city,"functionName":setCityisEmpty},
                {"fieldName":addressState,"functionName":setAddressStateisEmpty},
                {"fieldName":county,"functionName":setCountyisEmpty}
            ]

            isEmptyValidationArray.forEach(item=>{
                if(!isEmptyValidation(item.fieldName,item.functionName))
                    isValidAddress=false 
            })

            if(!isEmptyValidation(zipCode, setZipCodeisEmpty, zipCode.replace(/\s/g, "").length <= 4))
                    isValidAddress=false 
            

            if(!isValidAddress)
            {
                window.scrollTo(0, 530);
            }

            return isValidAddress;
        }
      }));

    

    const address_1_handleChange = address_1 => {
        setAddress_1(address_1.target.value); setAddress_1_isEmpty(false);
    }

    const address_2_handleChange = address_2 => {
        setAddress_2(address_2.target.value);
    }

    const cityHandleChange = city => {
        setCity(city.target.value); setCityisEmpty(false);
    }

    const stateHandleChange = state => {
        countiesListFromState = [];
        setAddressState(state); setAddressStateisEmpty(false); setCounty("");
        if (state !== null && state.label !== null) {
            constantOptions.countyOptions.forEach(item => {
                if (item.state === state.label) {
                    countiesListFromState.push(item);
                }
            });
        }
    }

    const zipCodeHandleChange = zipCode => {
        setZipCode(zipCode.target.value); setZipCodeisEmpty(false);
    }

    const countyHandleChange = county => {
        setCounty(county); setCountyisEmpty(false);
    }

    return (
        <div className="inner-card">
            <div className="card-header">
                Address
            </div>
            <div className="card-inner-body">
                <div className="tds-row">

                    <div className="tds-column" >
                        <div className={address_1_isEmpty ? "tds-validation" : ""}>
                            <label htmlFor="address_1">Address 1*</label>
                            <input type="text" id="address_1" name="address_1" value={address_1} onChange={address_1_handleChange} placeholder="Address 1" maxLength={50} autoComplete="none"/>
                        </div>
                    </div>
                    <div className="tds-column">
                        <label htmlFor="address_2">Address 2</label>
                        <input type="text" id="address_2" name="address_2" value={address_2} onChange={address_2_handleChange} placeholder="Address 2" maxLength={50} autoComplete="none"/>
                    </div>
                    <div className="tds-column">
                        <div className={cityisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="city">City*</label>
                            <input type="text" id="city" name="city" value={city} onChange={cityHandleChange} placeholder="City" maxLength={25} autoComplete="none"/>
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={addressStateisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="state">State*</label>
                            <Select
                                className={"custom_select_box"}
                                options={constantOptions.addressStateOptions.sort(compair)}
                                id={"addressState"}
                                value={addressState}
                                handleChange={stateHandleChange}
                            />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={zipCodeisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="zipCode">Zip Code*</label>
                            {/* <input type="number" id="zipCode" name="zipCode" value={zipCode} onChange={zipCodeHandleChange} placeholder="ZipCode" /> */}
                            <InputMask
                                id="zipCode"
                                name="zipCode"
                                value={zipCode}
                                pattern={"zipCode"}
                                handleChange={zipCodeHandleChange}
                                placeholder={"ZipCode"}
                                autoComplete="none"
                            />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={countyisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="county">County*</label>
                            <Select
                                className={"custom_select_box"}
                                options={countiesListFromState.sort(compair)}
                                id={"county"}
                                value={county}
                                handleChange={countyHandleChange}
                            />
                        </div>
                    </div>

                </div>

              
            </div>
        </div>
    )
});
export default AddressTab;